/*
 * @Author: Teemo Ding
 * @Date: 2021-06-28 13:56:01
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-13 11:46:26
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelOrder/OrderIdFormat/index.tsx
 */

import { Input, Radio } from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { QuestionCircleFilled } from '@ant-design/icons';
import { Form } from 'antd';
import React, { Fragment } from 'react';
import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipContent,
  TooltipTitle,
} from 'src/components/GlobalTooltip/WhiteBackgroundTooltip';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import css from '../css.module.less';

const IDPrefix = ({ getI18n }) => [
  {
    label: getI18n('salesChannelOrder.index.iDPrefix1'),
    value: false,
  },
  {
    label: getI18n('salesChannelOrder.index.iDPrefix2'),
    value: true,
  },
];
const IDSuffix = ({ getI18n }) => [
  {
    label: getI18n('salesChannelOrder.index.iDSuffix1'),
    value: false,
  },
  {
    label: getI18n('salesChannelOrder.index.iDSuffix2'),
    value: true,
  },
];

const labelTooltip = (type, { getI18n }) => {
  const text = replaceI18nVariables(
    getI18n('salesChannelOrder.index.orderIDtype'),
    type,
  );
  return (
    <div className={css.title}>
      {text}
      <WhiteBackgroundTooltip
        title={
          <TooltipContainer>
            <TooltipTitle>{text}</TooltipTitle>
            <TooltipContent>
              {replaceI18nVariables(
                getI18n('salesChannelOrder.index.orderIDContent'),
                type,
              )}
            </TooltipContent>
          </TooltipContainer>
        }
        placement='rightTop' //overlayClassName
      >
        <QuestionCircleFilled className={css.icon} />
      </WhiteBackgroundTooltip>
    </div>
  );
};

const OrderIdFormat = ({ disableEdit }: { disableEdit?: boolean }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.invoiceFormat}
      title={getI18n('salesChannelOrder.index.orderIDFormat')}
      subtitle={getI18n('salesChannelOrder.index.orderIDFormatSub')}>
      <Row
        elements={[
          {
            child: (
              <Fragment>
                <Form.Item
                  labelCol={{
                    span: 24,
                  }}
                  label={labelTooltip(getI18n('general.prefix'), { getI18n })}
                  name='enableCustomisePrefix'>
                  <Radio
                    disabled={disableEdit}
                    className={css.informationCustomized}
                    radioList={IDPrefix({ getI18n })}></Radio>
                </Form.Item>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) =>
                    prevValues.enableCustomisePrefix !==
                    currentValues.enableCustomisePrefix
                  }>
                  {({ getFieldValue }) => (
                    <Form.Item
                      name={
                        getFieldValue('enableCustomisePrefix')
                          ? 'prefix'
                          : 'defaultPrefix'
                      }
                      rules={[
                        {
                          pattern: /^[0-9a-zA-Z-]{1,}$/,
                          message: getI18n('general.invalidformat'),
                        },
                      ]}>
                      <Input
                        disabled={
                          !getFieldValue('enableCustomisePrefix') || disableEdit
                        }
                        size='large'
                        className={css.input}
                      />
                    </Form.Item>
                  )}
                </Form.Item>
              </Fragment>
            ),
          },
          {
            child: (
              <Fragment>
                <Form.Item
                  labelCol={{
                    span: 24,
                  }}
                  label={labelTooltip(getI18n('general.suffix'), { getI18n })}
                  name='enableCustomiseSuffix'>
                  <Radio
                    disabled={disableEdit}
                    className={css.informationCustomized}
                    radioList={IDSuffix({ getI18n })}></Radio>
                </Form.Item>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) =>
                    prevValues.enableCustomiseSuffix !==
                    currentValues.enableCustomiseSuffix
                  }>
                  {({ getFieldValue }) => (
                    <Form.Item
                      name={
                        getFieldValue('enableCustomiseSuffix')
                          ? 'suffix'
                          : 'defaultSuffix'
                      }
                      rules={[
                        {
                          pattern: /^[0-9a-zA-Z-]{1,}$/,
                          message: getI18n('general.invalidformat'),
                        },
                      ]}>
                      <Input
                        disabled={
                          !getFieldValue('enableCustomiseSuffix') || disableEdit
                        }
                        size='large'
                        className={css.input}
                      />
                    </Form.Item>
                  )}
                </Form.Item>
              </Fragment>
            ),
          },
        ]}
      />
    </SectionWrapper>
  );
};

export default OrderIdFormat;
